import { render, staticRenderFns } from "./Snacks.vue?vue&type=template&id=8f1fda2c&"
import script from "./Snacks.vue?vue&type=script&lang=js&"
export * from "./Snacks.vue?vue&type=script&lang=js&"
import style0 from "./Snacks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Snacks.vue"
export default component.exports